import { VoltageReference } from 'clipsal-cortex-types/src/api/api-ww-meter';
import { CORTEX_SUPPORT_URL } from 'clipsal-cortex-utils/src/constants/common-constants';

import packageJson from '../../package.json';
import { ElectricalConfiguration } from '../api/api-site';
import { ENV_TYPE_SHORTHAND } from '../env-type';
import { REGION_SHORTHAND } from '../region-type';
import { SelectOption } from './types/types';

export const SUPPORT_EMAIL = 'techsupport.pz@se.com';
export const APPLE_APP_STORE_URL = 'https://apps.apple.com/us/app/clipsal-solar-pulse-installer/id1583705822';
export const ANDROID_PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.clipsalsolar.onboarding';
export const MACQUARIE_TENANT_ID = 28;
export const WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
export const COMPONENT_MIN_HEIGHT = 'calc(100vh - env(safe-area-inset-bottom) - env(safe-area-inset-top))';
export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const ALLOWED_COUNTRIES = ['Australia', 'United States', 'New Zealand'];

export const ALLOWED_COUNTRIES_SELECT_OPTIONS = ALLOWED_COUNTRIES.map((c) => ({ label: c, value: c }));

export const COMMON_CHART_DATETIME_FORMATS = {
  second: '%l:%M:%S %P',
  minute: '%l:%M %P',
  hour: '%l %P',
  day: '%e. %b',
  week: '%e. %b',
  month: "%b '%y",
  year: '%Y',
};

export const BOTTOM_NAV_HEIGHT = 'calc(58px + env(safe-area-inset-bottom))';

// Select option arrays
export const VOLTAGE_CONFIGURATIONS: SelectOption<ElectricalConfiguration>[] = [
  { value: '1ph', label: '1 Phase' },
  { value: '2ph', label: '2 Phase' },
  { value: '3ph', label: '3 Phase' },
];

export const VOLTAGE_REFERENCE_TYPES: SelectOption<VoltageReference>[] = [
  { value: 'P1', label: 'Phase A' },
  { value: 'P2', label: 'Phase B' },
  { value: 'P3', label: 'Phase C' },
];

export const CONTROLLED_LOAD_ASSIGNMENT_TYPES = ['load_hot_water', 'load_underfloor_heating'];

export const SMART_SAVE_ENABLED_LOAD_ASSIGNMENT_TYPES = ['load_hot_water', 'load_hot_water_solar'];

// UI constants
export const SIDENAV_WIDTH = '250px';

export const TOP_NAV_HEIGHT = 48;
export const TOP_NAV_SPACING_AFFORDANCE = `${TOP_NAV_HEIGHT}px`;

export const APP_VERSION = packageJson.version;

// need to add cortexEnvType as capacitor builds are always in production mode
export const IS_PRODUCTION =
  import.meta.env['MODE'] === 'production' && localStorage.getItem('cortexEnvType') !== 'STAGING';
export const IS_RUNNING_CYPRESS_TESTS = !!window.Cypress;
export const IS_RUNNING_HEADLESS =
  /HeadlessChrome/.test(window.navigator.userAgent) || /headless/i.test(navigator.appVersion);

export const IS_NOT_DEVELOPMENT = import.meta.env.MODE !== 'development';

export const IS_PRODUCTION_BUILD = IS_PRODUCTION && !IS_RUNNING_CYPRESS_TESTS && !IS_RUNNING_HEADLESS;

export const ENDPOINT =
  localStorage.getItem('customEndpoint') ||
  (import.meta.env?.[`VITE_${REGION_SHORTHAND}_${ENV_TYPE_SHORTHAND}_ENDPOINT`] as string);
export const USER_POOL_ID =
  localStorage.getItem('customCognitoUserPoolId') ||
  (import.meta.env?.[`VITE_${REGION_SHORTHAND}_${ENV_TYPE_SHORTHAND}_COGNITO_USER_POOL_ID`] as string);
export const CLIENT_ID =
  localStorage.getItem('customCognitoUserPoolClientId') ||
  (import.meta.env?.[`VITE_${REGION_SHORTHAND}_${ENV_TYPE_SHORTHAND}_CLIENT_ID`] as string);

export const WIZARD_HEIGHT = 56;

export const CORTEX_METER_TROUBLESHOOTING_URL = CORTEX_SUPPORT_URL;
